import { render, staticRenderFns } from "./TasksCard.vue?vue&type=template&id=43a0b20a&scoped=true&"
import script from "./TasksCard.vue?vue&type=script&lang=js&"
export * from "./TasksCard.vue?vue&type=script&lang=js&"
import style0 from "./TasksCard.vue?vue&type=style&index=0&id=43a0b20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a0b20a",
  null
  
)

export default component.exports